module.exports = __webpack_public_path__ + "static/media/Investor-LAUREN BECKSTED_1646320440758.0ac5d8dc.vtt";